var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.7778,
    height: 41.7778,
    rx: 20,
    fill: "#6EE796"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35205 20.889C4.35205 13.0933 4.35205 9.19552 6.77384 6.77372C9.19564 4.35193 13.0935 4.35193 20.8891 4.35193C28.6848 4.35193 32.5825 4.35193 35.0044 6.77372C37.4261 9.19552 37.4261 13.0933 37.4261 20.889C37.4261 28.6845 37.4261 32.5824 35.0044 35.0043C32.5825 37.426 28.6848 37.426 20.8891 37.426C13.0935 37.426 9.19564 37.426 6.77384 35.0043C4.35205 32.5824 4.35205 28.6845 4.35205 20.889Z",
    stroke: "black",
    strokeWidth: 2.61111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1854 29.5926L19.4854 22.2928M19.4854 22.2928L12.1854 12.1852H17.0208L22.293 19.485M19.4854 22.2928L24.7574 29.5926H29.5928L22.293 19.485M29.5928 12.1852L22.293 19.485",
    stroke: "black",
    strokeWidth: 2.61111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.181376782f57d4c76fe615af4c7e5cb2.svg";
export { ForwardRef as ReactComponent };